import { WarningPolygon } from "react-huge-icons/outline";
import { useTranslation } from "react-i18next";

const OutdatedSoftwareInfo: React.FC = () => {
  const { t } = useTranslation();

  return (
    <>
      <div className="rounded-xl bg-content2 p-8 mb-8 relative overflow-hidden">
        <div className="absolute -right-11 top-2/3 transform -translate-y-1/2">
          <WarningPolygon className="h-56 w-56 opacity-10" />
        </div>
        <div className="flex flex-col">
          <h1 className="text-2xl text-danger font-medium pb-5 ">
            {t("Warning: Outdated Software Version")}
          </h1>
          <p className="text-textsecondary pb-5">
            {t(
              "We have detected that your ECU is running an outdated software version"
            )
              .split("\n")
              .map((line, i) => (
                <span key={i}>
                  {line}
                  <br />
                </span>
              ))}
          </p>
        </div>
      </div>
    </>
  );
};

export default OutdatedSoftwareInfo;
